import * as React from "react";
import {Button, Modal, ModalHeader, ModalBody} from 'reactstrap';
import {observer} from "mobx-react";
import {observable} from "mobx";

interface IInfoModalButton {
    icon?: string,
    text: string,
    modalTitle: string,
    modalClass?: string,
    buttonClass: string
    children: any
}

@observer
export class InfoModalButton extends React.Component<IInfoModalButton, any> {
    @observable modal = false;
    /*constructor(props: any) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
    }*/

    toggle = () => {
        /*this.setState({
            modal: !this.state.modal
        });*/
        this.modal = !this.modal;
    };

    render() {
        const {} = this.props;
        return (
            <>
                <Button color="parties" className={this.props.buttonClass} onClick={this.toggle}>
                    {this.props.icon ? <span className={this.props.icon}></span> : ''}{this.props.text}
                </Button>
                <Modal isOpen={this.modal} toggle={this.toggle} className={this.props.modalClass ? this.props.modalClass : ''}>
                    <ModalHeader toggle={this.toggle}>{this.props.modalTitle}</ModalHeader>
                    <ModalBody>
                        {this.props.children}
                    </ModalBody>
                </Modal>
            </>
        );
    }
}




// WEBPACK FOOTER //
// ./resources/js/components/InfoModalButton.tsx